import object from 'helpers/object'


export const initialState = {
  categories: [],
  isFetching: true,
}


export const setCategories = (state, payload) => (
  object.setIn(state, [ 'categories' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
